import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import { Ball, Number, TextPrimary } from "./index.style";

const StepTitle = ({ title = "", step_number = null, is_required = true }) => {
    return (
        <Flex vAlign="center" gap="gap.small">
            <Ball
                active={"true"}
                already={"true"}
                vAlign="center"
                hAlign="center"
            >
                <Number active={"true"} already={"true"}>
                    {step_number}
                </Number>
            </Ball>
            <TextPrimary>{title}</TextPrimary>
            {is_required && <Text styles={{ color: "red" }}>*</Text>}
        </Flex>
    );
};

export default StepTitle;
